import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0E44\u0E17\u0E22",
  code: "th",
  messages: {
    alert: {
      close: "\u0E1B\u0E34\u0E14"
    },
    authForm: {
      hidePassword: "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
      showPassword: "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
      submit: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D"
    },
    banner: {
      close: "\u0E1B\u0E34\u0E14"
    },
    calendar: {
      nextMonth: "\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E16\u0E31\u0E14\u0E44\u0E1B",
      nextYear: "\u0E1B\u0E35\u0E16\u0E31\u0E14\u0E44\u0E1B",
      prevMonth: "\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
      prevYear: "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32"
    },
    carousel: {
      dots: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E44\u0E25\u0E14\u0E4C\u0E17\u0E35\u0E48\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07",
      goto: "\u0E44\u0E1B\u0E17\u0E35\u0E48 {slide}",
      next: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
      prev: "\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A"
    },
    chatPrompt: {
      placeholder: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E1B\u0E49\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48..."
    },
    chatPromptSubmit: {
      label: "\u0E2A\u0E48\u0E07"
    },
    colorMode: {
      dark: "\u0E21\u0E37\u0E14",
      light: "\u0E2A\u0E27\u0E48\u0E32\u0E07",
      switchToDark: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E2B\u0E21\u0E14\u0E21\u0E37\u0E14",
      switchToLight: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E2B\u0E21\u0E14\u0E2A\u0E27\u0E48\u0E32\u0E07",
      system: "\u0E23\u0E30\u0E1A\u0E1A"
    },
    commandPalette: {
      back: "\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A",
      close: "\u0E1B\u0E34\u0E14",
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      noMatch: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
      placeholder: "\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E49\u0E19\u0E2B\u0E32..."
    },
    contentSearch: {
      links: "\u0E25\u0E34\u0E07\u0E01\u0E4C",
      theme: "\u0E18\u0E35\u0E21"
    },
    contentSearchButton: {
      label: "\u0E04\u0E49\u0E19\u0E2B\u0E32..."
    },
    contentToc: {
      title: "\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49"
    },
    dashboardSearch: {
      theme: "\u0E18\u0E35\u0E21"
    },
    dashboardSearchButton: {
      label: "\u0E04\u0E49\u0E19\u0E2B\u0E32..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u0E22\u0E48\u0E2D\u0E41\u0E16\u0E1A\u0E14\u0E49\u0E32\u0E19\u0E02\u0E49\u0E32\u0E07",
      expand: "\u0E02\u0E22\u0E32\u0E22\u0E41\u0E16\u0E1A\u0E14\u0E49\u0E32\u0E19\u0E02\u0E49\u0E32\u0E07"
    },
    dashboardSidebarToggle: {
      close: "\u0E1B\u0E34\u0E14\u0E41\u0E16\u0E1A\u0E14\u0E49\u0E32\u0E19\u0E02\u0E49\u0E32\u0E07",
      open: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E16\u0E1A\u0E14\u0E49\u0E32\u0E19\u0E02\u0E49\u0E32\u0E07"
    },
    error: {
      clear: "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01"
    },
    fileUpload: {
      removeFile: "\u0E25\u0E1A {filename}"
    },
    header: {
      close: "\u0E1B\u0E34\u0E14\u0E40\u0E21\u0E19\u0E39",
      open: "\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E21\u0E19\u0E39"
    },
    inputMenu: {
      create: '\u0E2A\u0E23\u0E49\u0E32\u0E07 "{label}"',
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      noMatch: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19"
    },
    inputNumber: {
      decrement: "\u0E25\u0E14",
      increment: "\u0E40\u0E1E\u0E34\u0E48\u0E21"
    },
    modal: {
      close: "\u0E1B\u0E34\u0E14"
    },
    pricingTable: {
      caption: "\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E17\u0E35\u0E22\u0E1A\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0E22\u0E48\u0E2D",
        name: "\u0E42\u0E04\u0E49\u0E14",
        openText: "\u0E02\u0E22\u0E32\u0E22"
      },
      collapsible: {
        closeText: "\u0E0B\u0E48\u0E2D\u0E19",
        name: "\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34",
        openText: "\u0E41\u0E2A\u0E14\u0E07"
      },
      pre: {
        copy: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E42\u0E04\u0E49\u0E14\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14"
      }
    },
    selectMenu: {
      create: '\u0E2A\u0E23\u0E49\u0E32\u0E07 "{label}"',
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      noMatch: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
      search: "\u0E04\u0E49\u0E19\u0E2B\u0E32..."
    },
    slideover: {
      close: "\u0E1B\u0E34\u0E14"
    },
    table: {
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25"
    },
    toast: {
      close: "\u0E1B\u0E34\u0E14"
    }
  }
});
